var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60722 16.4168C6.29055 15.6834 7.33223 15.7417 7.93223 16.5417L8.77389 17.6667C9.44889 18.5584 10.5406 18.5584 11.2156 17.6667L12.0572 16.5417C12.6572 15.7417 13.6989 15.6834 14.3822 16.4168C15.8656 18.0001 17.0739 17.4751 17.0739 15.2584V5.86675C17.0739 2.50842 16.2906 1.66675 13.1406 1.66675H6.84056C3.69056 1.66675 2.90723 2.50842 2.90723 5.86675V15.2501C2.91556 17.4751 4.13222 17.9918 5.60722 16.4168Z",
    stroke: "#7539FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70801 8.33325H12.2913",
    stroke: "#7539FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionMinus);
export default __webpack_public_path__ + "static/media/transaction-minus.4e38bebf99b2689b1964550087dd2a13.svg";
export { ForwardRef as ReactComponent };